const borg = require('./providers/borg');

const basic = {
    init: true,
    lang: 'es',
    autocomplete: {},
    cssValid: 'is-valid',
    cssError: 'has-error',
    onChange: []
};

const providers = {
    borg: {
        ...basic,
        provider: borg
    }
};

module.exports = function fn(providerName = 'borg') {
    return providers[providerName] || providers.borg;
};
